import React from 'react';
import { cn } from '../utils/cn';
export function Tabs({ tabs, activeTab: controlledTab, defaultTab, onChange, className }) {
  const [internalTab, setInternalTab] = React.useState(defaultTab ?? tabs[0]?.id ?? '');
  const activeTab = controlledTab ?? internalTab;
  const handleTabClick = (tabId) => {
    if (controlledTab === undefined) {
      setInternalTab(tabId);
    }
    onChange?.(tabId);
  };
  return (
    <div className={cn('border-b border-edge-strong', className)} role="tablist">
      <nav className="-mb-px flex" aria-label="Tabs">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={`tabpanel-${tab.id}`}
              id={`tab-${tab.id}`}
              onClick={() => handleTabClick(tab.id)}
              className={cn(
                'inline-flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors',
                isActive
                  ? 'border-fg text-fg'
                  : 'border-transparent text-fg-tertiary hover:border-edge hover:text-fg-secondary',
              )}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span
                  className={cn(
                    'rounded-full px-2 py-0.5 text-xs font-medium',
                    isActive
                      ? 'bg-neutral-200 text-fg'
                      : 'bg-surface-muted text-fg-tertiary',
                  )}
                >
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
export const TabPanel = React.forwardRef(function TabPanel(
  { tabId, activeTab, className, children, ...props },
  ref,
) {
  if (tabId !== activeTab) return null;
  return (
    <div
      ref={ref}
      role="tabpanel"
      id={`tabpanel-${tabId}`}
      aria-labelledby={`tab-${tabId}`}
      className={cn('py-4', className)}
      {...props}
    >
      {children}
    </div>
  );
});
